import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ResponseBase } from "../../data";
import { MetricJsonGenResponse, Metrics } from "../../data/metrics";

export interface MetricsState {
  response: ResponseBase | null;
  isLoading: boolean;
  error: ResponseBase | null;
  metricsList: Metrics[];
  metricJsonGenResponse: MetricJsonGenResponse | null;
}

const initialState: MetricsState = {
  response: null,
  isLoading: false,
  error: null,
  metricsList: [],
  metricJsonGenResponse: null
};

const metricsSlice = createSlice({
  name: "metricsSlice",
  initialState: initialState,
  reducers: {
    setResponse(state, action: PayloadAction<ResponseBase | null>) {
      state.response = action.payload;
      state.isLoading = false;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setMetricsList(state, action: PayloadAction<Metrics[]>) {
      state.metricsList = action.payload;
      state.isLoading = false;
    },
    setMetricJsonGenResponse(state, action: PayloadAction<MetricJsonGenResponse | null>) {
      state.metricJsonGenResponse = action.payload;
      state.isLoading = false;
    },
    setError(state, action: PayloadAction<ResponseBase | null>) {
      state.isLoading = false;
      state.error = action.payload;
    }
  }
});

export const metricsActions = metricsSlice.actions;
export default metricsSlice;
